// extracted by mini-css-extract-plugin
export default {"promo-code":"PromoCodeField_promo-code__AUjS9"};